import { useEffect, useState } from "react";
import { setActor, getActorName } from "@/api/client";
import { getUser } from "@/lib/auth";

// Bootstrap-Reihenfolge: localStorage > Keycloak > leer.
// Keycloak ist nach main.tsx's `ensureAuth().then(render)` garantiert
// initialisiert, also liefert getUser() einen sinnvollen Wert sobald
// dieser Hook das erste Mal aufgerufen wird.
function initialName(): string | null {
  const stored = getActorName();
  if (stored) return stored;
  const u = getUser();
  if (u && u.name) {
    setActor(u.name);
    return u.name;
  }
  return null;
}

export function useIdentity() {
  const [name, setName] = useState<string | null>(initialName);
  useEffect(() => {
    function onStorage(e: StorageEvent) {
      if (e.key === "macoAnalyst") setName(e.newValue);
    }
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);
  const update = (n: string) => {
    setActor(n);
    setName(n.trim());
  };
  return { name, setName: update, hasIdentity: !!name && name.length > 0 };
}
